//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppProduct from './Product.vue'
import TransitionToggle from '../transitions/Toggle.vue'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: "AppProducts",
  components: {
    AppProduct,
    TransitionToggle
  },
  data() {
    return {
      media: window.matchMedia('(min-width: 768px)'),
      top: '0px'
    }
  },
  computed: {
    ...mapGetters(['products', 'max', 'size']),
    disableRemove() {
      return this.size <= 2;
    },
    disableAdd() {
      return this.size >= this.max;
    },
  },
  methods: {
    ...mapMutations(['addComparison', 'removeComparison']),
    setTop() {
			let headerHeight = document.querySelector('.header__inner').offsetHeight;
			this.top = `top: ${headerHeight}px`;
    }
  },
  mounted() {
    setTimeout(this.setTop, 500);
    window.addEventListener('resize', this.setTop);
  }
}
